<div class="c-block c-block--bordered">
  <dl class="c-detail__list">
    <dt class="c-detail__list-name">Property Details</dt>
    <dt class="c-detail__list-title">Address</dt>
    <dd class="c-detail__list-description">{{Address}}</dd>
    @if (isDip) {
      <dt class="c-detail__list-title">What type of property is it?</dt>
    }
    @if (isDip) {
      <dd class="c-detail__list-description">{{PropertyType}}</dd>
    }
    @if (isDip) {
      <dt class="c-detail__list-title">Number of bedrooms</dt>
    }
    @if (isDip) {
      <dd class="c-detail__list-description">{{Bedrooms}}</dd>
    }
    <dt class="c-detail__list-title">Auction date</dt>
    <dd class="c-detail__list-description">{{AuctionDate}}</dd>
    <dt class="c-detail__list-title">Auction house</dt>
    <dd class="c-detail__list-description">{{AuctionHouse}}</dd>
  </dl>
  @if (showEditButton) {
    <button class="c-button c-button--neutral" type="button" (click)="editButtonClicked()">
      Edit property details
      <svg class=" c-button__icon c-button__icon--right icon-arrow-right " aria-hidden="true " focusable="false " xmlns="http://www.w3.org/2000/svg " viewBox="0 0 8.06 14.71 "><path fill="none " stroke="#2f3432 " stroke-miterlimit="10 " d="M.35 14.35l7-7-7-7 " /></svg>
    </button>
  }
</div>
